function push() {
    const navigation = document.getElementById('navigation')
    const navigationHeight = navigation.offsetHeight;
    const elementsPadding = document.querySelectorAll('.pt-hero');
    const elementsMargin = document.querySelectorAll('.mt-hero');

    elementsPadding.forEach(function (item) {
        item.style.paddingTop = navigationHeight + 'px';
    });

    elementsMargin.forEach(function (item) {
        item.style.marginTop = navigationHeight + 'px';
    });
}

push();
window.addEventListener('resize', push);
